/* eslint-disable react/no-unescaped-entities */
import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import Button, { Color } from "../../../../../../../../../components/Form/Button";
import { Wrapper, PlusIcon, Title, DescriptionContainer, Description } from "./styles";

const defaultIcon = require("Assets/img/empty-estimated-quote.svg");

type BrandEmptySectionProps = {
  onAdd: () => void;
};

export const BrandEmptySection: React.FC<BrandEmptySectionProps> = (props) => {
  const { onAdd } = props;

  const { t: translate } = useTranslation();

  return (
    <Wrapper
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={3}
      data-cy="brand-empty"
    >
      <Grid item xs={12}>
        <img src={defaultIcon} alt="empty state" />
      </Grid>
      <Grid item xs={4}>
        <Title>{translate("itLooksLikeThereSNoDataYet")}</Title>
      </Grid>
      <DescriptionContainer item xs={4}>
        <Description>{`${translate("youCanStartByAddingANewBrandName")}`}</Description>
      </DescriptionContainer>
      <Grid item xs={3}>
        <Button onClick={onAdd} customColor={Color.PRIMARY} data-cy={"addBrandbutton"}>
          <PlusIcon color="#ffffff" size={16} />
          {translate("addNewBrandName")}
        </Button>
      </Grid>
    </Wrapper>
  );
};
